import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { Form, Input, Button, Row, Col, Checkbox } from "antd";

import partnersApi from "../../apis/Partners.api";
import { setChannelUser, setUser } from "../../redux/store/auth/authDuck";
import { setLoading } from "../../redux/store/common/commonDuck";

const SignInComponent = () => {
	const history = useHistory();
	const dispatch = useDispatch();

	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));
	const [form] = Form.useForm();

	const [loginForm, setLoginForm] = useState({
		user_id: null,
		password: null,
	});

	const [cookies, setCookie, removeCookie] = useCookies(["rememberUserId"]); // cookie 이름
	const [isRemember, setIsRemember] = useState(false); // 아이디 저장 체크박스

	useEffect(() => {
		/*저장된 쿠키값이 있으면, CheckBox TRUE 및 UserID에 값 셋팅*/
		if (cookies.rememberUserId !== undefined) {
			setLoginForm({ ...loginForm, user_id: cookies.rememberUserId });
			form.setFieldsValue({
				...form.getFieldsValue(),
				user_id: cookies.rememberUserId,
				errors: null,
			});
			setIsRemember(true);
		}
	}, [cookies]);

	useEffect(() => {
		const timer = setTimeout(() => {
			window.scrollTo({
				top: 0,
				behavior: "smooth",
			});
			return () => clearTimeout(timer);
		}, 100);
	}, []);

	const handleCheckbox = (e) => {
		setIsRemember(e.target.checked);
		if (!e.target.checked) {
			removeCookie("rememberUserId");
		}
	};

	const handleSubmit = async () => {
		setIsLoading(true);
		const res = await partnersApi.login(loginForm);
		if (res.code === 200) {
			localStorage.setItem(
				"admin:accessToken",
				res.result.tokenDto.accessToken
			);
			localStorage.setItem(
				"admin:refreshToken",
				res.result.tokenDto.refreshToken
			);
			dispatch(
				setUser({
					...res.result.user,
					longlife_channel_id: res.result?.channelInfo?.longlife_channel_id,
					longlife_user_id: res.result?.channelInfo?.longlife_user_id,
				})
			);
			dispatch(
				setChannelUser({
					...res.result.user,
					longlife_channel_id: res.result?.channelInfo?.longlife_channel_id,
					longlife_user_id: res.result?.channelInfo?.longlife_user_id,
				})
			);
			setIsLoading(false);
			// history.push(`/products`)
			setCookie("rememberUserId", loginForm.user_id);
			history.push(`/`);
		} else if (res.code === 997 || res.code === 998) {
			if (res.code === 997) {
				form.setFields([
					{ name: "user_id", errors: ["유효한 아이디가 아닙니다."] },
				]);
			} else {
				form.setFields([
					{ name: "password", errors: ["비밀번호가 일치하지 않습니다."] },
				]);
			}
			alert(res.msg);
		} else {
			alert(
				"로그인하는데 오류가 발생했습니다.\n다시 시도해주시거나 관리자에게 문의해주시길 바랍니다."
			);
		}
		setIsLoading(false);
	};

	const handleChange = (changedValues) => {
		for (const key in changedValues) {
			setLoginForm({
				...loginForm,
				[key]: changedValues[key] === "" ? null : changedValues[key],
			});
			form.setFields([{ name: key, errors: null }]);
		}
	};

	return (
		<Row
			justify="space-between"
			align="middle"
			className="responsive-content-padding login-content"
			gutter={{ sm: 18, md: 12, lg: 0 }}
		>
			<Col className="together-content-login-col">
				<img
					src={`${process.env.REACT_APP_HOST}/assets/images/main/togetherLogin.png`}
					className="together-content-login-img noselect"
					alt={`투게더 로그인`}
				/>
			</Col>
			<Col className="together-content-login-col">
				<Form
					className="together-content-login-form-wrap"
					layout="vertical"
					form={form}
					requiredMark={false}
					onValuesChange={handleChange}
				>
					<img
						src={`${process.env.REACT_APP_HOST}/assets/images/main/togetherLogo.png`}
						className="together-content-login-form-logo noselect"
					/>
					{/*<div className="together-login-form-help-text">SNS로 <span className="together-login-form-help-text-bold">1초만에 로그인/회원가입</span>하고{"\n"}간편하게 수익을 창출해보세요!</div>*/}
					<div className="together-login-form-help-text">
						회원ID, 비밀번호를 잊으셨다면{"\n"}
						<span className="together-login-form-help-text-bold">
							담당자를 통해 문의
						</span>
						해주세요!
					</div>
					<Form.Item
						label="아이디"
						name="user_id"
						style={{
							width: "60%",
							marginBottom: 20,
						}}
					>
						<Input
							className="together-login-id-input"
							onPressEnter={handleSubmit}
						/>
					</Form.Item>
					<Form.Item
						label="비밀번호"
						name="password"
						style={{
							marginBottom: 10,
							width: "60%",
						}}
					>
						<Input.Password
							className="together-login-password-input"
							onPressEnter={handleSubmit}
						/>
					</Form.Item>
					<Form.Item
						style={{
							// marginTop: "-10px",
							marginBottom: 0,
							width: "60%",
						}}
					>
						<Checkbox checked={isRemember} onChange={(e) => handleCheckbox(e)}>
							아이디 저장
						</Checkbox>
					</Form.Item>
					<Form.Item
						className="together-login-button-wrap"
						style={{
							width: "60%",
						}}
					>
						<Button
							className="together-login-button"
							onClick={handleSubmit}
							disabled={Object.values(loginForm).some((value) => !value)}
							loading={isLoading}
						>
							{isLoading ? "" : "로그인"}
						</Button>
					</Form.Item>
				</Form>
			</Col>
		</Row>
	);
};
export default SignInComponent;
